var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"name-wrapper",attrs:{"to":{name: 'ViewClient', params: {id: _vm.client.id}}}},[_c('UserAvatar',{attrs:{"user":_vm.client}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }